<template>
    <v-lazy><div class="section fade-in grey-card">
      <v-container class="px-15" fluid>
      <v-row justify="center">
          
        <v-col cols="12" md="4">
            <h2 class="section__header-title">Segment Management</h2>
            <h2 class="text-subtitle-1 mb-5">Track engagement and performance over time</h2>
                <div class="mb-5">
                    <h3>Import rules</h3>
                    Allow for dynamic segment creation.
                </div>
                <div class="mb-5">
                    <h3>Testing</h3>
                    Set-up A-B testing on segment treatments.
                </div>
                <div class="mb-5">
                    <h3>Comms Management</h3>
                    Manage automated daily messaging campaigns, and fine tune delivery speeds.

                </div>
                <div class="mb-5">
                    <h3>Monitoring</h3>
                    Track engagement and collections results over time.
                </div>
                <div class="mb-5">
                    <h3>Simple Integration</h3>
                    Easily import and export data on daily schedules.
                </div>
                
                
                
                
                
          </v-col>
          <v-col cols="12" md="4">
          <v-img
          src="../assets/img/segments.png"
          class="mx-auto"
          max-width="800"
          contain/>
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
}
</script>

<style lang="scss">


</style>